import styled from "styled-components";

export const EmptyStateContainer = styled.div`
  margin: 4rem 0;
`;
